// utils/keplerTimeUtils.js
import { toZonedTime, format } from 'date-fns-tz';

const SANTIAGO_TZ = 'America/Santiago';

export function patchCsvTimezone(csvString) {
  const lines = csvString.split('\n');
  if (lines.length < 2) return csvString;

  const header = lines[0];
  const cols = header.split(',');
  const etIdx = cols.findIndex(c => c.trim() === 'event_time');
  if (etIdx === -1) return csvString;

  const newLines = [header]; // sin columna extra, solo parchamos event_time

  for (let i = 1; i < lines.length; i++) {
    const line = lines[i];
    if (!line.trim()) continue;

    const parts = line.split(',');
    const rawTs = parts[etIdx]?.trim();

    try {
      const d = new Date(rawTs);
      if (!isNaN(d.getTime())) {
        const zoned = toZonedTime(d, SANTIAGO_TZ);
        parts[etIdx] = format(zoned, 'yyyy-MM-dd HH:mm:ss', {
          timeZone: SANTIAGO_TZ,
        });
      }
    } catch {
      // deja valor original
    }

    newLines.push(parts.join(','));
  }

  return newLines.join('\n');
}
